import request from '@/utils/request2';
export function checkRediect(data) {
  return request.post('admin/message/check-redirect', data);
}